import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Upload,
  DatePicker,
  notification,
  TimePicker,
} from "antd";
import ReactQuill from "react-quill";
import moment from "moment";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { addeditdatafreezes,freezesList } from "../../../controllers/V1/cms/campaignController";
import "react-quill/dist/quill.snow.css";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../components/Loading/LoadingEffect";
const { Option } = Select;

const Freezes = () => {
  const location = useLocation();
  const state = location.state; // State for edit mode
  const [isLoading, setIsLoading] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({});
  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  const getFreezingData = async () => {
    try {
      const options = {
        type: "",
      };
      const listData = await freezesList(options);
      if (listData.status === true) {
        setInitialValues(listData?.result);
        } 
        setIsLoading(false);
    
    } catch (error) {
      setIsLoading(false);

   console.error(error)
    }
  };
  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const formattedValues = {
        ...values,
        editId: state?._id || undefined, // Pass ID in edit mode
      };
      const res = await addeditdatafreezes(formattedValues);
      if (res.status === true) {
        notification.success({
          message: "Success",
          description: "Data successfully added/updated.",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate("/campaign/freezes");
      } else {
        notification.error({
          message: "Error",
          description: res.message,
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error during submission:", error);
    }
  };

  const handleValuesChange = (changedValues) => {
    if ("enable_number_range_prefix" in changedValues) {
      // setShowNumberRangePrefix( changedValues.enable_number_range_prefix === "Y" );
    }
  };
  useEffect(() => {
    getFreezingData()
    document.title = `Orbit Kuwait || freeze's ${
      state?._id ? "edit" : "add"
    }`;
  }, [state]);

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {state?._id ? "Edit" : "Add"} Freezes
        </h5>
        <Link to="/campaign/list">
          <Button type="secondary">
            <ArrowLeftOutlined /> Back
          </Button>
        </Link>
      </div>

      <div className="card shadow mb-4 dataBase_table_Add_Data">
        <div style={{ padding: "20px" }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={initialValues}
            onValuesChange={handleValuesChange}
          >
            <Row gutter={16}>
                        <Col span={8}>
                              <Form.Item
                                label="Campaign Freezing"
                                name="campaign_freezing"
                              >
                                <Select>
                                  <Option value="Enable">Enable</Option>
                                  <Option value="Disable">Disable</Option>
                                </Select>
                              </Form.Item>
                            </Col>
              <Col span={8}>
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[
                    { required: true, message: "Please enter the title!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={8}>
                              <Form.Item
                                label="Auto Campaign Freezing"
                                name="auto_campaign_freezing"
                              >
                                <Select>
                                  <Option value="Enable">Enable</Option>
                                  <Option value="Disable">Disable</Option>
                                </Select>
                              </Form.Item>
                            </Col>
            </Row>

            <Row gutter={16}>
           
              <Col span={8}>
                <Form.Item
                  label="Freezing Time Start"
                  name="Freezing_time_start"
                  rules={[
                    { required: true, message: "Please select a freezing time!" },
                  ]}
                >
                  <input
                    type="time"
                    className="form-control store_input_field"
                    id="Freezing_time_start"
                    value={
                      initialValues?.Freezing_time_start || ""
                    } // Bind form state
                    onChange={
                      (e) => form.setFieldsValue({ draw_time: e.target.value }) // Update form state
                    }
                    disabled={!!state?._id}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Freezing Time End"
                  name="freezing_time_end"
                  rules={[
                    { required: true, message: "Please select a freezing timee end!" },
                  ]}
                >
                  <input
                    type="time"
                    className="form-control store_input_field"
                    id="freezing_time_end"
                    value={ initialValues?.freezing_time_end || '21:31:00'}
                    onChange={
                      (e) => form.setFieldsValue({ freezing_time_end: e.target.value }) // Update form state
                    }
                    disabled={!!state?._id}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="verndor_dashboard_add_edit_button text-center">
              <button
                type="submit"
                class="btn btn-primary inventory_save_button"
              >
                Save
              </button>
            </div>
          </Form>
        </div>
      </div>
      <Loading isLoading={isLoading} />
    </div>
  );
};

export default Freezes;
